import React from 'react';
import { ProfileInputField } from './ProfileInputField';
import { ProfileDocumentField } from './ProfileDocumentField';

interface ProfileContactFieldsProps {
  nombreCompleto: string;
  celular: string;
  tipoIdentificacion: string;
  numeroIdentificacion: string;
  email?: string;
  tipoDocs: string[];
  editableFields: Record<string, boolean>;
  onChange: (field: string, value: string) => void;
  onToggleEditField: (field: string) => void;
}

export const ProfileContactFields: React.FC<ProfileContactFieldsProps> = ({
  nombreCompleto,
  celular,
  tipoIdentificacion,
  numeroIdentificacion,
  email,
  tipoDocs,
  editableFields,
  onChange,
  onToggleEditField,
}) => {
  return (
    <div className="space-y-3.5">
      <ProfileInputField
        label="Nombre Completo"
        value={nombreCompleto}
        onChange={(val) => onChange('nombreCompleto', val)}
        isEditing={!!editableFields.nombreCompleto}
        onToggleEdit={() => onToggleEditField('nombreCompleto')}
        placeholder="Nombre y apellidos"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <ProfileInputField
          label="Correo Electrónico"
          value={email || ''}
          isReadOnly
        />
        <ProfileInputField
          label="Teléfono Celular"
          value={celular || 'No registrado'}
          isReadOnly
        />
      </div>

      <ProfileDocumentField
        tipoIdentificacion={tipoIdentificacion}
        numeroIdentificacion={numeroIdentificacion}
        tipoDocs={tipoDocs}
        isEditing={!!editableFields.documento}
        onToggleEdit={() => onToggleEditField('documento')}
        onChangeTipo={(val) => onChange('tipoIdentificacion', val)}
        onChangeNumero={(val) => onChange('numeroIdentificacion', val)}
      />
    </div>
  );
};
